/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRef, useCallback } from 'react';

/**
 * Custom hook for throttling a function call.
 * @param fn Function to throttle
 * @param delay Throttle interval in ms (default: 1000)
 * @returns Throttled function
 */
export function useThrottleFn<T extends (...args: any[]) => void>(fn: T, delay = 1000): T {
  const lastCallRef = useRef(0);

  return useCallback(
    (...args: Parameters<T>) => {
      const now = Date.now();
      if (now - lastCallRef.current < delay) return;
      lastCallRef.current = now;
      fn(...args);
    },
    [fn, delay]
  ) as T;
}
